<template>
  <!-- REMOVIDO TEMPORARIAMENTE PARA TESTES
    <div v-if="!hasFirstOrder"> 
        <fake-orders />
    </div>
    <div v-else>
  -->
  <div>
    <orders />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FakeOrders from './Orders/FakeOrders.vue'
import Orders from './Orders/Orders.vue'
export default {
    components: {
        FakeOrders,
        Orders
    },
    computed: {
        ...mapState({
            hasFirstOrder: (state) => state.store.configurations.hasFirstOrder
        })
    }
}
</script>
